// extracted by mini-css-extract-plugin
export default {"root":"styles_root__+c+te","main":"styles_main__lfG-1"};